<form #SiteHolidayForm="ngForm">
    <div class="row pb-2 m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                [routerLink]="['/master/holiday/branch/add/0/0']" [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Branch Holiday Mapping':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card">
        <div class="card-header">
            <div class="card-title">Branch Holiday </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-1">
                    <label>Year : </label>
                </div>
                <div class="col-md-2">
                    <select name="Year" (change)="GetBranchHoliday()" class="form-select" [(ngModel)]="filter.Year"
                        #Year="ngModel" required>
                        <option *ngFor="let Year of Years" [value]="Year">
                            {{Year}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="pt-2">
            </div>
            <table datatable [dtOptions]="this.dtoptions" width="100%" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered pt-2">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th>Branch Name</th>
                        <th style="width: 10px;">Year</th>
                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let element of HolidayData">
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i
                                    [routerLink]="['/master/holiday/branch/add/'+element['Branchid']+'/'+ element['Year']]"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td> {{element['Branchname']}}</td>
                        <td style="width: 10px;">{{element['Year']}}</td>
                    </tr>
                </tbody>
            </table>

        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">

                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                        (click)="exportToExcel()">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button>
                    &nbsp;
                    <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                        (click)="downloadExcel()">
                        <i class="bi bi-file-earmark-excel" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Sample':'Loading...'}}
                    </button>
                    &nbsp;
                    <label *ngIf="this.common.PageRight.IsPrint" for="file-upload" class="btn btn-sm btn-primary">
                        <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                    </label>
                    <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                        accept=".xls,.xlsx">
                </div>
            </div>
        </div>
    </div>
</form>